import { createApi } from "@reduxjs/toolkit/query/react";
import {
  TrendingSidebarParams,
  TrendingSidebarStock,
  TrendingStocksResponse,
  WatchlistResponse,
  TrendingStocksParams,
  WatchlistParams,
} from "./trendingStocksApiData";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const trendingStocksApi = createApi({
  reducerPath: "trendingStocksApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getTrendingStocks: build.query<TrendingStocksResponse, TrendingStocksParams>({
      query: (params) => ({
        url: "/finance/trending",
        params,
      }),
    }),

    getTrendingSidebarStocks: build.query<TrendingSidebarStock[], TrendingSidebarParams>({
      query: (params) => ({
        url: "/finance/trending",
        params,
      }),
    }),

    getTrendingWatchlist: build.query<WatchlistResponse, WatchlistParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .filter(([_, value]) => value !== undefined && value !== null && value !== "")
          .map(([key, value]) => `${key}=${value}`)
          .join("&");

        return {
          url: `/watchlist?${queryString}`,
        };
      },
    }),

    addToFavorite: build.mutation<
      {
        createdAt: string;
        userId: number;
        instrumentId: number;
        message: string;
      },
      string
    >({
      query: (symbol) => ({
        url: `/follow/${symbol}`,
        method: "POST",
      }),
    }),

    removeFromFavorite: build.mutation<
      {
        createdAt: string;
        userId: number;
        instrumentId: number;
        message: string;
      },
      string
    >({
      query: (symbol) => ({
        url: `/follow/${symbol}`,
        method: "DELETE",
      }),
    }),
    getCompanyLogo: build.query<string, string>({
      query: (symbol) => `/finance/company-logo?symbol=${symbol}`,
      transformResponse: (response: { logoUrl: string }) => response.logoUrl,
    }),
  }),
});

export const {
  useGetTrendingStocksQuery,
  useGetTrendingSidebarStocksQuery,
  useGetTrendingWatchlistQuery,
  useAddToFavoriteMutation,
  useRemoveFromFavoriteMutation,
  useGetCompanyLogoQuery,
} = trendingStocksApi;
